<template>
  <transition name="fade">
    <section class="cursor-pointer" @click="clickOutside">
      <article class="cursor-auto bg-white pt-4 pb-8 px-8 w-full max-w-3xl">
        <div class="flex justify-end text-3xl pt-4 pb-8">
          <div
            class="cursor-pointer transition-all duration 200 hover:text-secondary-500"
            @click="hideModal"
          >
            <BaseIcon name="times" />
          </div>
        </div>
        <p>
          Este contenido solo está disponible para usuarios registrados. Por
          favor, accede a tu cuenta o regístrate.
        </p>
        <div class="mt-12 flex justify-center">
          <div class="mx-2">
            <BaseButton :to="{ name: 'Login', query: { next: $route.path } }"
              >Acceder</BaseButton
            >
          </div>
          <div class="mx-2">
            <BaseButton :to="{ name: 'Register' }">Regístrate</BaseButton>
          </div>
        </div>
      </article>
    </section>
  </transition>
</template>

<script>
export default {
  methods: {
    clickOutside(e) {
      if (e.target instanceof HTMLElement && this.$el === e.target) {
        this.hideModal()
      }
    },

    hideModal() {
      this.$store.commit('videos/setShowVideoAuthModal', false)
    },
  },
}
</script>

<style scoped>
section {
  @apply fixed w-full h-screen inset-0 flex items-center justify-center z-10 rounded px-4;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
